var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaitingForDelivery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.614258 4.18619C0.614258 2.34525 2.10664 0.852859 3.94759 0.852859H25.2809C27.1219 0.852859 28.6143 2.34525 28.6143 4.18619V13.5195H27.2809V4.18619C27.2809 3.08162 26.3855 2.18619 25.2809 2.18619H3.94759C2.84302 2.18619 1.94759 3.08162 1.94759 4.18619V25.5195C1.94759 26.6241 2.84302 27.5195 3.94759 27.5195H13.2809V28.8529H3.94759C2.10664 28.8529 0.614258 27.3605 0.614258 25.5195V4.18619Z",
    fill: "#5192F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9476 1.51953C9.9476 1.15134 10.2461 0.852859 10.6143 0.852859H18.6143C18.9824 0.852859 19.2809 1.15134 19.2809 1.51953V10.8529C19.2809 11.0672 19.1779 11.2684 19.0041 11.3937C18.8303 11.519 18.6068 11.5531 18.4035 11.4853L14.6143 10.2223L10.8251 11.4853C10.6218 11.5531 10.3983 11.519 10.2245 11.3937C10.0506 11.2684 9.9476 11.0672 9.9476 10.8529V1.51953ZM11.2809 2.18619V9.92791L14.4035 8.88707C14.5403 8.84146 14.6883 8.84146 14.8251 8.88707L17.9476 9.92791V2.18619H11.2809Z",
    fill: "#5192F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2809 15.5195C17.9672 15.5195 15.2809 18.2058 15.2809 21.5195C15.2809 24.8333 17.9672 27.5195 21.2809 27.5195C24.5947 27.5195 27.2809 24.8333 27.2809 21.5195C27.2809 18.2058 24.5947 15.5195 21.2809 15.5195ZM13.9476 21.5195C13.9476 17.4694 17.2308 14.1862 21.2809 14.1862C25.3311 14.1862 28.6143 17.4694 28.6143 21.5195C28.6143 25.5697 25.3311 28.8529 21.2809 28.8529C17.2308 28.8529 13.9476 25.5697 13.9476 21.5195Z",
    fill: "#5192F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6143 21.5195V18.1862H21.9476V21.1075L24.2457 22.2566L23.6495 23.4491L20.9828 22.1158C20.7569 22.0029 20.6143 21.7721 20.6143 21.5195Z",
    fill: "#5192F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingForDelivery);
export default __webpack_public_path__ + "static/media/waitingForDelivery.edf909c6566729947558f7c2f427171e.svg";
export { ForwardRef as ReactComponent };